import { Navigate, useSearchParams } from 'react-router-dom';
import { CircleAlert } from 'lucide-react';
import { Button, Callout, Card, Logo, Spinner } from '@elbklar/ui';

import { useAuth } from '@/features/auth/AuthContext';
import { rueckweg } from '@/features/auth/sitzung';

export function LoginPage() {
  const { isAuthenticated, isLoading, loginWithGoogle, error } = useAuth();
  // `?ziel=` setzt der API-Client, wenn die Sitzung wirklich vorbei ist: die
  // Seite, auf der man war. Nach der Anmeldung geht es dorthin zurück.
  const [params] = useSearchParams();
  const ziel = rueckweg(params.get('ziel'));

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <Spinner size={32} label="Anmeldung wird geprüft" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={ziel} replace />;
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4 py-10">
      <Card className="w-full max-w-md">
        <div className="mb-8 mt-4 flex flex-col items-center text-center">
          <Logo variant="horizontal" height={40} className="mb-6" />
          <h1 className="t-page-title">Finanzen</h1>
          <p className="mt-2 text-muted-foreground">
            Die Anmeldung läuft über den zentralen Elbklar-Zugang. Wer im CRM angemeldet ist, kommt ohne zweite Anmeldung
            hier hinein.
          </p>
        </div>

        {error && <Callout tone="danger" icon={CircleAlert} title={error} boxed className="mb-6" />}

        <Button variant="primary" size="lg" className="w-full" onClick={() => loginWithGoogle(ziel)}>
          Mit Google anmelden
        </Button>
      </Card>
    </div>
  );
}
